import { useEffect, useMemo, useState } from "react";
import RouteCard from "@/components/rotta/RouteCard";
import { fetchRoutes } from "@/lib/api";
import { StateFilter } from "@/components/rotta/StateFilter";
import { SortFilter } from "@/components/rotta/SortFilter";
import { matchesState } from "@/lib/brStates";

const SORT_OPTIONS = [
  { value: "relevance", label: "Relevantes" },
  { value: "az", label: "A → Z" },
  { value: "za", label: "Z → A" },
  { value: "recent", label: "Mais recentes" },
];

const collator = new Intl.Collator("pt-BR", { sensitivity: "base" });

export default function Rotas() {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uf, setUf] = useState("all");
  const [sort, setSort] = useState("relevance");

  useEffect(() => {
    fetchRoutes().then((r) => { setRoutes(r); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const list = routes.filter((r) => matchesState(r.state, uf));
    const arr = [...list];
    if (sort === "relevance") {
      arr.sort((a, b) => {
        const va = a.verified ? 0 : 1;
        const vb = b.verified ? 0 : 1;
        if (va !== vb) return va - vb;
        return collator.compare(a.name || "", b.name || "");
      });
    } else if (sort === "az") arr.sort((a, b) => collator.compare(a.name || "", b.name || ""));
    else if (sort === "za") arr.sort((a, b) => collator.compare(b.name || "", a.name || ""));
    else if (sort === "recent") arr.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
    return arr;
  }, [routes, uf, sort]);

  return (
    <div data-testid="rotas-page" className="pt-32 pb-24">
      <div className="container-rotta">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[#C6A762] mb-5">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Rotas Verificadas</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-[1.0]">
            Curadoria de rotas para quem <span className="text-gold-gradient">vive a estrada.</span>
          </h1>
          <p className="text-[#B8B8B8] mt-5 leading-relaxed">
            Selecionamos roteiros de mototurismo pelo Brasil com critérios de segurança,
            paisagem, infraestrutura e experiência. Cada rota é testada e aprovada pela equipe ROTTA.
          </p>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3">
          <SortFilter value={sort} onChange={setSort} options={SORT_OPTIONS} testId="rotas-sort-filter" />
          <StateFilter value={uf} onChange={setUf} testId="rotas-state-filter" />
        </div>

        <div className="mt-8 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="card-rotta aspect-[3/4] animate-pulse bg-[#161616]" />
              ))
            : filtered.map((r) => <RouteCard key={r.slug} route={r} />)}
        </div>

        {!loading && filtered.length === 0 && (
          <p data-testid="rotas-empty-state" className="text-[#B8B8B8] text-center py-16">
            Nenhuma rota encontrada para este estado.
          </p>
        )}
      </div>
    </div>
  );
}
